<template>
  <v-row>
    <v-col cols="12" sm="12" md="12" class="mr-md-3" v-if="$allow('psp-peserta-kp-pa.update-pendampingan')">
      <div class="text-right">
        <v-btn color="orange" depressed dark @click="onEdit(kPertemuan)"> <v-icon left>mdi-pencil</v-icon> Ubah </v-btn>
      </div>
    </v-col>
    <template v-for="(item, i) in details">
      <v-col :key="i" v-bind="item.grid" v-if="!item.hidden" class="pa-0">
        <v-list two-line>
          <v-list-item>
            <v-list-item-avatar v-if="item.icon" color="blue">
              <v-icon dark>{{ item.icon }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <div>
                <div class="grey--text text--darken-1" v-html="item.title" />
              </div>
              <div class="black--text body-1">
                <div class="font-weight-medium" v-html="$getDeepObj(item, 'value') || ''" />
              </div>
              <div class="black--text">
                <template v-for="(info, id) in item.infos">
                  <div :key="id" class="mb-1 body-3">
                    <span class="grey--text text--darken-1">{{ info.label }}:&nbsp;</span>{{ info.value }}
                  </div>
                </template>
              </div>
              <template v-if="item.type === 'link'">
                <v-expansion-panels flat>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="px-0">
                      <template v-slot:default="{ open }">
                        <div>
                          <v-toolbar flat>
                            <v-toolbar-title class="body-1 ml-n4">
                              <v-avatar color="blue" size="40">
                                <v-icon dark>mdi-video</v-icon>
                              </v-avatar>
                              <span class="blue--text ml-2">
                                {{ item.meeting.length || 0 }}
                              </span>
                              <span class="font-weight-medium">Link Pertemuan Daring</span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <span class="text-right blue--text">
                              {{ open ? 'Sembunyikan Link' : 'Lihat Selengkapnya' }}
                            </span>
                          </v-toolbar>
                        </div>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <template v-if="item.meeting.length > 0">
                        <v-card color="yellow lighten-5" flat v-for="(meet, m) in item.meeting" :key="m">
                          <v-row>
                            <v-col v-for="child in item.child" :key="child.key" cols="12" sm="12" md="6">
                              <v-list-item>
                                <v-list-item-avatar :color="child.color">
                                  <v-icon dark>{{ child.icon }}</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <div>
                                    <div>
                                      <span v-html="child.title"></span>
                                      &nbsp;
                                      <span>{{ $getDeepObj(meet, 'nama') || '' }}</span>
                                    </div>
                                  </div>
                                  <div class="link black--text body-2">
                                    <span class="blue--text body-2 my-1">{{ $getDeepObj(meet, child.key) || '' }}</span>
                                    <div>
                                      <v-btn
                                        small
                                        outlined
                                        color="orange"
                                        :disabled="!$getDeepObj(meet, child.key)"
                                        @click="toLink($getDeepObj(meet, child.key))"
                                      >
                                        <v-icon left>mdi-open-in-new</v-icon> Buka Link
                                      </v-btn>
                                      <v-btn
                                        class="mx-md-1"
                                        small
                                        outlined
                                        color="orange"
                                        :disabled="!$getDeepObj(meet, child.key)"
                                        @click="toCopy($getDeepObj(meet, child.key))"
                                      >
                                        <v-icon left>mdi-content-copy</v-icon> Salin Link
                                      </v-btn>
                                    </div>
                                  </div>
                                </v-list-item-content>
                              </v-list-item>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                              <v-divider></v-divider>
                            </v-col>
                          </v-row>
                        </v-card>
                      </template>
                      <template v-else>
                        <div class="text-center body-1">
                          Belum ada data pertemuan daring
                        </div>
                      </template>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </template>
              <template v-if="item.type === 'file'">
                <div>
                  <v-btn small outlined :disabled="!item.url_berkas" color="orange" @click="toLink(item.url_berkas)">
                    <v-icon left>mdi-open-in-new</v-icon> Lihat Berkas
                  </v-btn>
                </div>
              </template>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </template>
  </v-row>
</template>
<script>
export default {
  name: 'DetailUmum',
  props: {
    details: {
      type: Array,
      default: () => [],
    },
    kPertemuan: {
      type: Number,
      required: true,
    },
  },
  methods: {
    onEdit() {
      this.$emit('edit', this.kPertemuan);
    },

    toLink(url) {
      this.$emit('toLink', url);
    },

    toCopy(url) {
      this.$emit('toCopy', url);
    },
  },
};
</script>

<style scoped></style>
